import {
  createMenu,
  deleteMenu,
  getMenu,
  updateMenu,
} from '@/api/menu';

import {
  getGroupBuyingsOrderMenu,
  getGroupBuyingsOrderMenuLimits,
  updateGroupBuyingsOrderMenu,
} from '@/api/orders';

import {
  CREATE_MENU,
  DELETE_MENU,
  GET_GROUP_BUYINGS_MENU,
  GET_GROUP_BUYINGS_MENU_LIMITS,
  GET_MENU_DONE,
  GET_MENU,
  IS_CREATING_MENU,
  IS_DELETING_MENU,
  IS_GETTING_MENU,
  IS_UPDATING_MENU,
  SET_MENU_DONE,
  SET_MENU,
  UPDATE_GROUP_BUYINGS_MENU,
  UPDATE_MENU,
} from './constants';

export default {
  async [CREATE_MENU]({ commit }, { storeId, menu }) {
    commit(IS_CREATING_MENU, true);
    try {
      const res = await createMenu(storeId, menu);
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      commit(IS_CREATING_MENU, false);
    }
  },
  async [DELETE_MENU]({ commit }, { menuId, storeId }) {
    commit(IS_DELETING_MENU, true);
    try {
      const res = await deleteMenu(storeId, menuId);
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      commit(IS_DELETING_MENU, false);
    }
  },
  async [GET_MENU]({ commit }, { menuId, storeId }) {
    commit(IS_GETTING_MENU, true);
    try {
      const { menu = {} } = await getMenu(storeId, menuId);
      commit(GET_MENU_DONE, menu);
      return Promise.resolve(menu);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      commit(IS_GETTING_MENU, false);
    }
  },
  async [UPDATE_MENU]({ commit }, { menuId, menu, storeId }) {
    commit(IS_UPDATING_MENU, true);
    try {
      const res = await updateMenu(storeId, menuId, menu);
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      commit(IS_UPDATING_MENU, false);
    }
  },
  [SET_MENU]({ commit }, menu = {}) {
    commit(SET_MENU_DONE, menu);
  },
  async [GET_GROUP_BUYINGS_MENU]({ commit }, orderId) {
    commit(IS_GETTING_MENU, true);
    try {
      const { menu = {} } = await getGroupBuyingsOrderMenu(orderId);
      commit(GET_MENU_DONE, menu);
      return Promise.resolve(menu);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      commit(IS_GETTING_MENU, false);
    }
  },
  async [GET_GROUP_BUYINGS_MENU_LIMITS]({ commit }, orderId) {
    commit(IS_GETTING_MENU, true);
    try {
      const { entree_limit: entreeLimit = {} } = await getGroupBuyingsOrderMenuLimits(orderId);
      return Promise.resolve(entreeLimit);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      commit(IS_GETTING_MENU, false);
    }
  },
  async [UPDATE_GROUP_BUYINGS_MENU]({ commit }, { menu, orderId }) {
    commit(IS_UPDATING_MENU, true);
    try {
      const res = await updateGroupBuyingsOrderMenu(orderId, menu);
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      commit(IS_UPDATING_MENU, false);
    }
  },
};
